import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Link } from 'react-router-dom';
import formatDateToBR from '../../utils/formatDateToBR';

const getImageUrl = (news) => {
    if (news.imageUrl) return news.imageUrl;

    const imageFile = news.featuredImage || news.imageNew || news.oldImage || news.image;

    return imageFile
        ? `https://a1media.antena1.com.br/image/news/482x250/${imageFile}`
        : '/thumbnail_Default.jpg';
};

const getDescription = (content = '') => content.replace(/<[^>]+>/g, '');

const SuperSimSponsoredNewsTeaser = ({ className = '', news }) => {
    const imageUrl = getImageUrl(news);
    const imageAlt = news.imageCaption || news.title;

    return (
        <article className={`superSimSponsoredNewsTeaser ${className}`.trim()}>
            <Link
                to={`/noticias/${news.slug}`}
                title={`Saiba mais sobre ${news.title}`}
                className="superSimSponsoredNewsTeaser__link"
            >
                <p className="alternativeFontSize tw-text-gray-500 data-publicacao superSimSponsoredNewsTeaser__date">
                    {formatDateToBR(news.date)}
                </p>

                <h3 className="tw-mb-3 limitText2 superSimSponsoredNewsTeaser__title">
                    {news.title}
                </h3>

                <figure className="superSimSponsoredNewsTeaser__figure">
                    <img
                        src={imageUrl}
                        alt={imageAlt}
                        className="superSimSponsoredNewsTeaser__image"
                        loading="eager"
                        decoding="async"
                    />
                </figure>

                <p className="tw-mb-0 limitText2 superSimSponsoredNewsTeaser__description">
                    {getDescription(news.content)}
                </p>
            </Link>
        </article>
    );
};

SuperSimSponsoredNewsTeaser.propTypes = exact({
    className: PropTypes.string,
    news: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        slug: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        imageUrl: PropTypes.string,
        imageCaption: PropTypes.string,
        featuredImage: PropTypes.string,
        imageNew: PropTypes.string,
        oldImage: PropTypes.string,
        image: PropTypes.string,
        content: PropTypes.string,
    }).isRequired,
});

export default SuperSimSponsoredNewsTeaser;
